<template>
    <SignIn />
</template>

<script>
import { defineComponent } from "vue";
import SignIn from "../../components/authentication/forms/SignIn.vue";

export default defineComponent({
    name: "SignInPage",
    components: {
        SignIn,
    },
});
</script>
